
import { Component, Inject, Optional, OnInit } from '@angular/core';
import {  MatDatepickerInputEvent, MatSnackBar,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'jalali-moment';
import { InvoiceService } from '../../../services/Acc_InvoiceService';
import { Txn_Invoice } from '../../../models/Txn_Invoice';

@Component({
  selector: 'app-edit-invoice-dialog',
  templateUrl: './edit-invoice-dialog.component.html',
  styleUrls: ['./edit-invoice-dialog.component.css']
})
export class EditInvoiceDialogComponent implements OnInit {
  inv_number: number;
  remarks: string;
  inv_Date: Date;
  expiryDate: Date;
  st_name: string;
  semester: number;
  year: string;
  season: string;

  this_inv: Txn_Invoice = {
    authStat :'',
    checkerID : '',
    clearBankRefNO:'',
    clearDate:null,
    clear_status:'',
    discount_amount:0,
    inv_amount:0,
    inv_no:0,
    issueDate:null,
    expiryDate: null,
    issue_remark:'',
    makerID:'',
    payable_amount:0,
    relatedAccount:'',
    semester:0,
    trn_ref_clear:'',
    trn_ref_issue:'',
    invoiceType:'',
    invoiceDesc: '',
    year: "",
    season: "",
    installmentNumber: 0,
    installmentNumbers: '',
    isRepeatSemester: false,
    userId: '',
    branchId: '',
    discountValue: 0,
    repeatSemesterSerie: 1,
    termId:0,
  }

  constructor(
    public dialogRef: MatDialogRef<EditInvoiceDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    this.inv_number = data.inv_number;
    this.inv_Date = new Date(data.inv_Date);
    this.expiryDate = new Date(data.expiryDate);
    console.log(`expiry date: ` + this.expiryDate);
    this.remarks = data.remarks;
    this.st_name = data.st_name;
    this.semester = data.semester;

    this.year = data.year;
    this.season = data.season;
     
  }

  ngOnInit() {
   
  }

  issueDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.inv_Date = new Date(_date);
    console.log(`issue date:` +this.inv_Date);
    //this.fromDate_DariDate = _pdate;
  }

  expiryDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.expiryDate = new Date(_date);
    console.log(`expiry date:` + this.expiryDate);
    //this.fromDate_DariDate = _pdate;
  }
  updateInvoice() {
    this.this_inv.issueDate = this.inv_Date;
    this.this_inv.issue_remark = this.remarks;
    this.this_inv.inv_no = this.inv_number;
    this.this_inv.semester = this.semester;
    this.this_inv.expiryDate = this.expiryDate;
    this.this_inv.year = this.year;
    this.this_inv.season  = this.season;

    //this.invoice_service.updateInvoice(this.this_inv);

    this.dialogRef.close({ event: 'close', data: this.this_inv });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: this.this_inv });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/management/edit-invoice-dialog/edit-invoice-dialog.component.ts